/**
 * Testers API Service
 */

import { api } from './api';

export interface TesterUser {
  id: string;
  email: string;
  name: string;
  username: string;
}

export interface ListTestersResponse {
  testers: TesterUser[];
  count: number;
}

export const testersApi = {
  /**
   * List users from Cognito (admin only)
   */
  list: async (): Promise<ListTestersResponse> => {
    return api.get<ListTestersResponse>('/admin/testers');
  },
};
